import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=113ff9a2&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=true&"
export * from "./Index.vue?vue&type=script&lang=true&"
import style0 from "./Index.vue?vue&type=style&index=0&id=113ff9a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113ff9a2",
  null
  
)

export default component.exports